import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SharedStatesModule } from 'shared-states';
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./components/footer/footer.component";
import { TranslateModule } from "@ngx-translate/core";
import { CookieStorageService } from "./services/cookie-storage.service";
import { TscBetaDirective } from "./directives/tsc-beta.directive";
import { CookieSettingsOverviewComponent } from './components/cookie-settings-overview/cookie-settings-overview.component';
import { SharedComponentsModule } from "shared-components";
import { TscDialogComponent } from './components/tsc-dialog/tsc-dialog.component';
import { MatDialogModule } from "@angular/material/dialog";
import { WebComponentsModule } from "teccom-web-components";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import {SvgAssetBundlerModule} from "./svg-asset-bundler/svg-asset-bundler.module";
import SvgAssetDictionary from "./svg-asset-source/svg-asset-dictionary";

@NgModule({
  declarations: [
    FooterComponent,
    CookieSettingsOverviewComponent,
    TscBetaDirective,
    TscDialogComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedStatesModule,
    TranslateModule,
    SharedComponentsModule,
    MatDialogModule,
    WebComponentsModule,
    SvgAssetBundlerModule.forYouAndMe({svgAssets: SvgAssetDictionary})
  ],
  exports: [
    CommonModule,
    FormsModule,
    SharedStatesModule,
    TranslateModule,
    SharedComponentsModule,
    FooterComponent,
    TscBetaDirective,
    TscDialogComponent,
    ConfirmDialogComponent,
    WebComponentsModule,
    SvgAssetBundlerModule
  ],
  providers: [
    CookieStorageService
  ]
})
export class ShellSharedModule {
  static forChild(): ModuleWithProviders<ShellSharedModule> {
    return {
      ngModule: ShellSharedModule
    };
  }
}

